
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'catalog-product-list-toolbar-sort-select',
})
export default class extends Vue {
  @Prop({ required: true }) readonly dataSource: string;

  private get sortOptions(): Array<object> {
    return this.$store.state[`${this.dataSource}`]['apiResponse']['sorting_options'] || [];
  }

  private get currentSorting(): object {
    return typeof this.$store.getters[`${this.dataSource}/currentSort`] !== 'undefined' ? this.$store.getters[`${this.dataSource}/currentSort`] : {};
  }

  private updatePage(e): void {
    const selectedOption = this.sortOptions[e.target.selectedIndex];
    let selectedOptionJson = '{}';

    if (null !== selectedOption['key']) {
      selectedOptionJson = `{"${selectedOption['key']}": "${selectedOption['sort'] || 'asc'}"}`;
    }

    this.$store.dispatch(`${this.dataSource}/updatePageSort`, JSON.parse(selectedOptionJson));
  }
}
